import React, {useState, useEffect, useRef} from 'react';
import './ToolTip.scss'

const ToolTip = ({children, tooltipText}) => {
    const [open, setOpen] = useState(false)
    const tooltipRef = useRef(null)

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
                event.preventDefault()
                event.stopPropagation()
                setOpen(false)
            }
        }

        if (open) {
            document.addEventListener('mousedown', handleClickOutside)
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [open])

    return (
        <div className={`toolTip ${open ? 'open' : ''}`} ref={tooltipRef}>
            <div onClick={() => setOpen(!open)}>{children}</div>
            <div className="toolTip__content" >{tooltipText}</div>
        </div>
    )
};

export default ToolTip;
